import Swal from "sweetalert2";

import api from "./api";
import { CreateRequestInProgressDto, GetRequestInProgressDto, UpdateRequestInProgressDto } from "../shared/dtos/RequestInProgress.dto";

class RequestInProgressService {
    async getAllRequestInProgress(): Promise<GetRequestInProgressDto[]> {
        return api
            .get("/request-in-progress/find-all")
            .then((response) => {
                return Promise.resolve(response.data as GetRequestInProgressDto[]);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao buscar lotações`);
                return Promise.reject(error);
            });
    }

    async getRequestInProgressById(id: number): Promise<GetRequestInProgressDto> {
        try {
            const response = await api.get(
                `request-in-progress/get-by-id/${id}`,
                {
                    timeout: 0,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error(
                `Erro ao buscar request in progress com ID ${id}`,
                error
            );
            throw error;
        }
    }

    async createRequestInProgress(formaPagamentoData: CreateRequestInProgressDto): Promise<GetRequestInProgressDto> {
        return api
            .post("/request-in-progress/create", formaPagamentoData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                this.handleError(error, "Erro ao criar lotação");
                return Promise.reject(error);
            });
    }

    async updateRequestInProgress(id: number, formaPagamentoData: UpdateRequestInProgressDto): Promise<GetRequestInProgressDto> {
        return api
            .patch(`/request-in-progress/update/${id}`, formaPagamentoData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao atualizar lotação com ID ${id}`);
                return Promise.reject(error);
            });
    }

    async deleteRequestInProgress(id: number): Promise<void> {
        return api
            .delete(`/request-in-progress/delete/${id}`)
            .then(() => {
                return Promise.resolve();
            })
            .catch((error) => {
                this.handleError(error, `Erro ao deletar lotação com ID ${id}`);
                return Promise.reject(error);
            });
    }

    async checkFinishedRequestInProgressById(id: number): Promise<boolean> {
        return api
            .get(`/request-in-progress/check-finished/${id}`)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao buscar request in progress com ID ${id}`);
                return Promise.reject(error);
            });
    }

    private handleError(error: any, message: string): void {
        if (error.response) {
            Swal.fire({
                title: "Erro",
                text: `${message}: ${error.response.data}`,
                icon: "error",
                confirmButtonText: "Fechar",
                allowOutsideClick: false,
            });
        } else {
            Swal.fire({
                title: "Erro",
                text: `${message}: ${error.message || "Erro desconhecido"}`,
                icon: "error",
                confirmButtonText: "Fechar",
                allowOutsideClick: false,
            });
        }
    }


}

const requestInProgressService = new RequestInProgressService();
export default requestInProgressService;
